// パスワード値を既定で伏せ、利用者の操作時だけ表示する共通入力を提供する。
import { useId, useState } from "react";
import { PiEye, PiEyeClosedLight } from "react-icons/pi";
import { cn } from "@/shared/lib";
import { Input, type InputProps } from "@/shared/ui/form/Input";

export interface PasswordInputProps extends Omit<InputProps, "type"> {
  visibilityLabel: string;
}

export const PasswordInput: React.FunctionComponent<PasswordInputProps> = ({
  className,
  id,
  visibilityLabel,
  ...props
}: PasswordInputProps) => {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  // 表示状態だけを切り替え、入力値とフォーカスは維持する。
  function handleVisibilityToggle(): void {
    setIsPasswordVisible((current) => !current);
  }

  return (
    <fieldset
      aria-label={visibilityLabel}
      className="m-0 flex min-w-0 items-center gap-2 border-0 p-0"
    >
      <Input
        {...props}
        id={inputId}
        type={isPasswordVisible ? "text" : "password"}
        className={cn("min-w-0 flex-1", className)}
      />
      <button
        type="button"
        aria-controls={inputId}
        aria-label={`${visibilityLabel}を${isPasswordVisible ? "隠す" : "表示"}`}
        className="inline-flex min-h-11 min-w-11 shrink-0 items-center justify-center rounded-lg border border-border bg-muted text-foreground hover:bg-accent focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
        onClick={handleVisibilityToggle}
      >
        {isPasswordVisible ? (
          <PiEye aria-hidden="true" className="h-5 w-5" />
        ) : (
          <PiEyeClosedLight aria-hidden="true" className="h-5 w-5" />
        )}
      </button>
    </fieldset>
  );
};

PasswordInput.displayName = "PasswordInput";
